/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Simplified)
export default {
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-description': '请向您的团队或管理员寻求支持。',
  'proforma-jira-portal-create.error-flag-handler.portal-create-view-object-search-error-title': '无法从此次搜索中获得任何结果'
};